import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function DownTrendIcon({ className }: Props) {
  const { t } = useLingui()

  return (
    <svg
      data-testid="down-trend-icon"
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Trend / Down">
        <title>{t`Down Trend Icon`}</title>
        <path id="Polygon 2" d="M6 8L9 4H3L6 8Z" fill="currentColor" />
      </g>
    </svg>
  )
}
